import { render, staticRenderFns } from "./photo-card.vue?vue&type=template&id=19824c2e&scoped=true&"
import script from "./photo-card.vue?vue&type=script&lang=js&"
export * from "./photo-card.vue?vue&type=script&lang=js&"
import style0 from "./photo-card.vue?vue&type=style&index=0&id=19824c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19824c2e",
  null
  
)

export default component.exports